import { ActionBar as ActionBar$1, ActionBarGroup, VerticalDivider, ActionBarIconButton } from './ActionBar.js';

const ActionBar = Object.assign(ActionBar$1, {
  IconButton: ActionBarIconButton,
  Divider: VerticalDivider,
  Group: ActionBarGroup
});

export { ActionBar, ActionBar as default };
